import { API_URL } from './js/shared/config/config';
import React, { useEffect, useState } from 'react';
import BaseRequest from './js/shared/http-requests/BaseRequest';
import DOMPurify from 'dompurify';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/es/map';
import 'core-js/es/set';
import './css/app.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import 'moment/locale/pt-br';
import 'moment/locale/es';
import {
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faArrowLeft,
    faArrowRight,
    faArrowAltCircleLeft,
    faArrowAltCircleRight,
    faHourglassStart,
    faHourglassHalf,
    faArrowUp,
    faBars,
    faBan,
    faBell,
    faBold,
    faBookmark,
    faBookOpen,
    faBookReader,
    faBullhorn,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faClock,
    faCog,
    faCogs,
    faDatabase,
    faEraser,
    faExclamationCircle,
    faExclamationTriangle,
    faEye,
    faEyeSlash,
    faFillDrip,
    faFilter,
    faFlag,
    faHeadset,
    faHistory,
    faImage,
    faInfo,
    faInfoCircle,
    faLanguage,
    faLink,
    faList,
    faListUl,
    faLock,
    faLockOpen,
    faLowVision,
    faMapMarkerAlt,
    faPaperPlane,
    faPlaceOfWorship,
    faPlus,
    faTicketAlt,
    faQrcode,
    faQuestion,
    faQuestionCircle,
    faSearch,
    faShare,
    faSave,
    faShoppingBag,
    faShoppingBasket,
    faSignInAlt,
    faSignLanguage,
    faSignOutAlt,
    faSortAmountDown,
    faSortAmountDownAlt,
    faStar,
    faTimes,
    faTimesCircle,
    faToggleOff,
    faToggleOn,
    faTrashAlt,
    faUniversalAccess,
    faUnlockAlt,
    faUser,
    faStreetView,
    faUserCircle,
    faFileAlt,
    faGlobe,
    faArrowsAltH,
    faHandPointUp,
    faHome,
    faSpinner,
    faSitemap,
    faShoppingCart,
    faPercent,
    faCubes,
    faFileSignature,
    faUserFriends,
    faIdCard,
    faRedoAlt,
    faFileInvoice,
    faPrint,
    faExternalLinkAlt,
    faTruck,
    faBook,
    faUserLock,
    faArchive,
    faBuilding,
    faChartBar,
    faChartLine,
    faEnvelope,
    faEnvelopeOpen,
    faUserShield,
    faUserCog,
    faMapSigns,
    faMinus,
} from '@fortawesome/free-solid-svg-icons';
import {
    faClock as farClock,
    faCommentDots,
    faComments,
    faCircle,
    faDotCircle,
    faFilePdf,
    faFolderOpen,
    faLightbulb,
    faFileWord,
} from '@fortawesome/free-regular-svg-icons';
import {
    faChrome,
    faFirefox,
    faEdge,
} from '@fortawesome/free-brands-svg-icons';
import Routers from './js/routers';

const icons = {
    faUser,
    faChevronUp,
    faUniversalAccess,
    faSearch,
    faAngleDown,
    faBars,
    faLowVision,
    faFillDrip,
    faBold,
    faToggleOff,
    faToggleOn,
    faSignLanguage,
    faBookmark,
    faHistory,
    faInfo,
    faBell,
    faExclamationTriangle,
    faQuestion,
    faAngleRight,
    faArrowUp,
    faHeadset,
    faCommentDots,
    faShoppingBag,
    faDatabase,
    faLanguage,
    faClock,
    faBookReader,
    faChevronDown,
    faMapMarkerAlt,
    farClock,
    faEraser,
    faTimesCircle,
    faCircle,
    faPlus,
    faTicketAlt,
    faLock,
    faLockOpen,
    faSortAmountDownAlt,
    faSortAmountDown,
    faShoppingBasket,
    faFilter,
    faUserCircle,
    faDotCircle,
    faExclamationCircle,
    faInfoCircle,
    faComments,
    faUnlockAlt,
    faEyeSlash,
    faQuestionCircle,
    faSignInAlt,
    faEye,
    faPlaceOfWorship,
    faArrowRight,
    faChevronRight,
    faChevronLeft,
    faSignOutAlt,
    faCog,
    faCheck,
    faPaperPlane,
    faLink,
    faCheckCircle,
    faAngleLeft,
    faAngleDoubleRight,
    faListUl,
    faBookOpen,
    faList,
    faImage,
    faQrcode,
    faAngleDoubleLeft,
    faTimes,
    faStar,
    faShare,
    faTrashAlt,
    faLightbulb,
    faFilePdf,
    faArrowLeft,
    faBullhorn,
    faFlag,
    faStreetView,
    faFolderOpen,
    faFileAlt,
    faGlobe,
    faArrowsAltH,
    faHandPointUp,
    faHome,
    faSpinner,
    faArrowAltCircleLeft,
    faArrowAltCircleRight,
    faHourglassStart,
    faSitemap,
    faShoppingCart,
    faPercent,
    faCubes,
    faFileSignature,
    faUserFriends,
    faIdCard,
    faBan,
    faRedoAlt,
    faCogs,
    faSave,
    faFileInvoice,
    faPrint,
    faExternalLinkAlt,
    faHourglassHalf,
    faTruck,
    faBook,
    faUserLock,
    faArchive,
    faBuilding,
    faChartBar,
    faChartLine,
    faEnvelope,
    faEnvelopeOpen,
    faUserShield,
    faUserCog,
    faFileWord,
    faChrome,
    faFirefox,
    faEdge,
    faMapSigns,
    faMinus
};
library.add(...Object.values(icons));

function aplicarVariaveisNaRoot(variaveis = {}) {
    const root = document.documentElement;
    Object.entries(variaveis).forEach(([nome, valor]) => {
        root.style.setProperty(nome, valor);
    });
}

function aplicarVariaveisNaClasse(classe, variaveis = {}) {
  const elementos = document.querySelectorAll(`.${classe}`);
  elementos.forEach(el => {
    Object.entries(variaveis).forEach(([nome, valor]) => {
      el.style.setProperty(nome, valor);
    });
  });
}

// Função para validar e sanitizar dados de estilo
function validateStyleData(data) {
    const validatedData = {};
    
    // Validar propriedades esperadas.
    if (data && typeof data === 'object') {
        // Sanitizar propriedades de cor (devem seguir formato de cor CSS)
        const colorPattern = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$|^rgb\(\d+,\s*\d+,\s*\d+\)$|^rgba\(\d+,\s*\d+,\s*\d+,\s*[\d.]+\)$/;
        
        if (typeof data.tema === 'string' && (colorPattern.test(data.tema) || data.tema.length < 50)) {
            validatedData.tema = data.tema;
        }
        if (typeof data.tema_consulta_dark === 'string' && (colorPattern.test(data.tema_consulta_dark) || data.tema_consulta_dark.length < 50)) {
            validatedData.tema_consulta_dark = data.tema_consulta_dark;
        }
        if (typeof data.btn_principal_cor === 'string' && (colorPattern.test(data.btn_principal_cor) || data.btn_principal_cor.length < 50)) {
            validatedData.btn_principal_cor = data.btn_principal_cor;
        }
        if (typeof data.btn_principal_cor_fonte === 'string' && (colorPattern.test(data.btn_principal_cor_fonte) || data.btn_principal_cor_fonte.length < 50)) {
            validatedData.btn_principal_cor_fonte = data.btn_principal_cor_fonte;
        }
        if (typeof data.btn_principal_cor_dark === 'string' && (colorPattern.test(data.btn_principal_cor_dark) || data.btn_principal_cor_dark.length < 50)) {
            validatedData.btn_principal_cor_dark = data.btn_principal_cor_dark;
        }
        if (typeof data.btn_principal_cor_fonte_dark === 'string' && (colorPattern.test(data.btn_principal_cor_fonte_dark) || data.btn_principal_cor_fonte_dark.length < 50)) {
            validatedData.btn_principal_cor_fonte_dark = data.btn_principal_cor_fonte_dark;
        }
        
        // Validar booleanos de permissão
        if (typeof data.google_analytics_permission === 'boolean') {
            validatedData.google_analytics_permission = data.google_analytics_permission;
        }
        if (typeof data.permissaoRybena === 'boolean') {
            validatedData.permissaoRybena = data.permissaoRybena;
        }
        if (typeof data.permissaoVLibras === 'boolean') {
            validatedData.permissaoVLibras = data.permissaoVLibras;
        }
        // Validar strings com limites de tamanho e caracteres seguros
        if (typeof data.title === 'string' && data.title.length <= 100) {
            validatedData.title = data.title;
        }
        if (typeof data.cookiePuc === 'string' && data.cookiePuc.length < 10000) {
            validatedData.cookiePuc = data.cookiePuc;
        }
        
        if (typeof data.script_analytics === 'string') {
            validatedData.script_analytics = data.script_analytics;
        }
        
        // Para CSS, permitir apenas se for string e não muito grande
        if (typeof data === 'string' && data.length < 50000) {
            validatedData.cssContent = data;
        }
    }
    
    return validatedData;
}

// Helper: parse an HTML string and inject any <script> tags (external or inline) into the document
function injectScriptsFromString(scriptString) {
    if (!scriptString || typeof document === 'undefined') return;
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(scriptString, 'text/html');
        const scripts = doc.querySelectorAll('script');

        scripts.forEach(s => {
            const newScript = document.createElement('script');
            // copy attributes such as src, async, defer, type
            for (let i = 0; i < s.attributes.length; i++) {
                const attr = s.attributes[i];
                if (attr.name === 'src') {
                    newScript.src = attr.value;
                } else if (attr.name === 'async') {
                    newScript.async = true;
                } else if (attr.name === 'defer') {
                    newScript.defer = true;
                } else {
                    newScript.setAttribute(attr.name, attr.value);
                }
            }

            // if it's an inline script, copy its content
            if (!s.src) {
                newScript.textContent = s.textContent;
            }

            document.body.appendChild(newScript);
        });

        // If no <script> tags found, insert the whole string as an inline script
        if (scripts.length === 0) {
            const inline = document.createElement('script');
            inline.textContent = scriptString;
            document.body.appendChild(inline);
        }
    } catch (e) {
        // don't throw; log and continue
        // eslint-disable-next-line no-console
        console.error('Erro ao injetar scripts:', e);
    }
}

const App = () => {
    useEffect(() => {
        async function carregarEstilos() {
            try {
            const stylesStorage = sessionStorage.getItem('styles_config');
            let estilosCSS = null;
            if (stylesStorage) {
                estilosCSS = JSON.parse(stylesStorage);
            } else {
                const response = await BaseRequest.axiosInst.get(
                    `${API_URL}/styles`
                );
                estilosCSS = response.data;
                sessionStorage.setItem('styles_config', JSON.stringify(estilosCSS));
            }
            // Validar dados recebidos.
            const dadosValidados = validateStyleData(estilosCSS);
            
            aplicarVariaveisNaRoot({
                '--cor-tema': dadosValidados.tema || '#000000',
                '--cor-secundaria': dadosValidados.tema || '#000000',
                '--primeiro': dadosValidados.btn_principal_cor || '#007bff',
                '--primeiro-texto': dadosValidados.btn_principal_cor_fonte || '#ffffff'
            })
            
            aplicarVariaveisNaClasse('contraste', {
                '--cor-tema': dadosValidados.tema_consulta_dark || '#ffffff',
                '--cor-secundaria': dadosValidados.tema_consulta_dark || '#ffffff',
                '--primeiro': dadosValidados.btn_principal_cor_dark || '#007bff',
                '--primeiro-texto': dadosValidados.btn_principal_cor_fonte_dark || '#ffffff'
            });
            
            // Aplicar CSS apenas se for uma string e foi validado
            if (dadosValidados.cssContent || (typeof estilosCSS === 'string' && estilosCSS.length < 50000)) {
                const styleTag = document.createElement('style');
                // Sanitize CSS content to prevent XSS
                const cssToUse = dadosValidados.cssContent || estilosCSS;
                const sanitizedCSS = DOMPurify.sanitize(cssToUse, { ALLOWED_TAGS: [] });
                styleTag.textContent = sanitizedCSS;
                document.head.appendChild(styleTag);
            }
            
            if (dadosValidados.cookiePuc) {
                const scriptTag = document.createElement('script');
                scriptTag.type = 'text/javascript';
                // Sanitize script content to prevent XSS
                const sanitizedScript = DOMPurify.sanitize(dadosValidados.cookiePuc, { ALLOWED_TAGS: [] });
                scriptTag.textContent = sanitizedScript;
                document.body.appendChild(scriptTag);
            }
            
            if (dadosValidados.title) {
                // Sanitize title to prevent XSS
                const sanitizedTitle = DOMPurify.sanitize(dadosValidados.title, { ALLOWED_TAGS: [] });
                // Additional validation: ensure title is a safe string and within reasonable length
                if (typeof sanitizedTitle === 'string' && sanitizedTitle.length <= 100) {
                    // Create a safe copy with additional encoding to prevent any potential injection
                    const safeTitle = String(sanitizedTitle).replace(/[<>'"&]/g, '');
                    // Final validation before setting
                    if (safeTitle && safeTitle.trim().length > 0 && safeTitle.length <= 100) {
                        document.title = safeTitle;
                    } else {
                        document.title = 'Pergamum';
                    }
                } else {
                    // Fallback to a safe default title
                    document.title = 'Pergamum';
                }
            }
            
            if (dadosValidados.google_analytics_permission) {
                // dadosValidados.script_analytics contém HTML; parse and inject scripts so they execute
                injectScriptsFromString(dadosValidados.script_analytics);
            }
            
            if (dadosValidados.permissaoRybena) {
                const rybenaScript = document.createElement('script');
                rybenaScript.src = '/js/libs/rybena.js?positionPlayer=left&positionBar=right';
                document.body.appendChild(rybenaScript);
            }
            
            if(dadosValidados.permissaoVLibras) {
                // Adiciona as divs necessárias para o VLibras
                const vlibrasDiv = document.createElement('div');
                vlibrasDiv.setAttribute('vw', '');
                vlibrasDiv.className = 'enabled';
                
                // Criar elementos de forma segura
                const accessButton = document.createElement('div');
                accessButton.setAttribute('vw-access-button', '');
                accessButton.className = 'active';
                
                const pluginWrapper = document.createElement('div');
                pluginWrapper.setAttribute('vw-plugin-wrapper', '');
                
                const topWrapper = document.createElement('div');
                topWrapper.className = 'vw-plugin-top-wrapper';
                
                pluginWrapper.appendChild(topWrapper);
                vlibrasDiv.appendChild(accessButton);
                vlibrasDiv.appendChild(pluginWrapper);
                
                document.body.appendChild(vlibrasDiv);

                const vlibrasScript = document.createElement('script');
                vlibrasScript.src = 'https://vlibras.gov.br/app/vlibras-plugin.js';
                vlibrasScript.onload = () => {
                    if (window.VLibras && window.VLibras.Widget) {
                        // eslint-disable-next-line no-new
                        new window.VLibras.Widget('https://vlibras.gov.br/app');
                    }
                };

                document.body.appendChild(vlibrasScript);
            }
            
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Erro ao carregar estilos:', error);
        }
        
    }

    carregarEstilos();
  }, []);
  return <Routers />;
};

export default App;
